import React from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ForWhom } from './components/ForWhom';
import { ProductIntro } from './components/ProductIntro';
import { Tomos } from './components/Tomos';
import { Bonuses } from './components/Bonuses';
import { Comparison } from './components/Comparison';
import { Results } from './components/Results';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
import { MetaPixel } from './components/MetaPixel';
import { useScreenInit } from './useScreenInit';
export function App() {
  useScreenInit();
  return <div className="min-h-screen bg-zinc-950 text-zinc-100 font-sans selection:bg-brand-500 selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Hero data-id="element-2" />
      <Testimonials data-id="element-3" />
      <PainPoints data-id="element-4" />
      <ForWhom data-id="element-5" />
      <ProductIntro data-id="element-6" />
      <Tomos data-id="element-7" />
      <Bonuses data-id="element-8" />
      <Comparison data-id="element-9" />
      <Results data-id="element-10" />
      <Pricing data-id="element-11" />
      <FAQ data-id="element-12" />
      <FinalCTA data-id="element-13" />
      <Footer data-id="element-14" />
      <PurchasePopup data-id="element-15" />
    </div>;
}